import React, { useState } from 'react'
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import { translate} from 'utils/common';

export default function TimePickerWrapper(props) {

    const format = 'h:mm a';

    // const value = 
    function prepareValue(){
        if(props.value){
            //TODO
            return moment().hour(props.value).minute(0)//.day("pm") 
        }else return moment().hour(0).minute(0);
    }
    
    function onChange(value) {
        console.log(value && value.format(format));
       props.onChange({ target: { name: props.name, value: value && value.format(format) } });
    }    

    return (
        <TimePicker
            showSecond={false}
            defaultValue={prepareValue()} 
            className="xxx"
            onChange={onChange}
            format={format}
            use24Hours
            inputReadOnly
        />
    )
}
